'use strict';

exports.__esModule = true;
exports.getVideoUrl = getVideoUrl;
exports.getVideoIdFromUrl = getVideoIdFromUrl;
function getVideoUrl(videoId) {
  var baseUrlPrefix = 'https://vimeo.com/';
  return baseUrlPrefix + videoId;
}

function getVideoIdFromUrl(url) {
  // TODO: add support for additional vimeo url formats
  var vimeoUrlRegex = /vimeo\.com\/(\d+)$/gi;
  var match = vimeoUrlRegex.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}
//# sourceMappingURL=vimeoVideoUtils.js.map